import { verify } from "@/api/launcherApp/signup"
import type { TApiSignupVerifyParams, TApiSignupVerifyResponse } from "@/api/launcherApp/signup/schema"
import { createScopedLogger } from "@/lib/observability"

const logger = createScopedLogger("signup", {
  action: "verify",
})

export async function actionVerifySignup(params: TApiSignupVerifyParams): Promise<{ success: boolean; data?: TApiSignupVerifyResponse }> {
  try {
    const result = await verify(params)
    return { success: true, data: result }
  } catch (error) {
    await logger.error("signup.verify.action_failed", error)
    return { success: false }
  }
}
